import Vue from 'vue'
import Icon from './components/Icon.vue'
import Slide from './components/Slide.vue'
import Tabs from './components/Tabs.vue'
import Button from './components/Button.vue'
import InputText from './components/InputText.vue'
import InputTextSearch from './components/InputTextSearch.vue'
import InputSelect from './components/InputSelect.vue'
import MusicCard from './components/MusicCard.vue'
import AnimationCard from './components/AnimationCard.vue'
import ModuleChart from './components/ModuleChart.vue'
import ModuleSpotifyPlaylist from './components/ModuleSpotifyPlaylist.vue'
import TrackCount from './components/TrackCount.vue'
import ModuleCard from './components/ModuleCard.vue'
import Modules from './components/Modules.vue'
import Footer from './components/Footer.vue'
import ModuleSocialBar from './components/ModuleSocialBar.vue'
import ModuleVideo from './components/ModuleVideo.vue'
import ModuleNewsletter from './components/ModuleNewsletter.vue'
import NavMenu from './components/NavMenu.vue'

Vue.component('Icon', Icon)
Vue.component('Slide', Slide)
Vue.component('Tabs', Tabs)
Vue.component('Button', Button)
Vue.component('InputText', InputText)
Vue.component('InputTextSearch', InputTextSearch)
Vue.component('InputSelect', InputSelect)
Vue.component('MusicCard', MusicCard)
Vue.component('AnimationCard', AnimationCard)
Vue.component('ModuleChart', ModuleChart)
Vue.component('ModuleSpotifyPlaylist', ModuleSpotifyPlaylist)
Vue.component('TrackCount', TrackCount)
Vue.component('ModuleCard', ModuleCard)
Vue.component('Modules', Modules)
Vue.component('Footer', Footer)
Vue.component('ModuleSocialBar', ModuleSocialBar)
Vue.component('ModuleVideo', ModuleVideo)
Vue.component('ModuleNewsletter', ModuleNewsletter)
Vue.component('NavMenu', NavMenu)
